//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      visible: false,
      buyParams: null
    };
  },
  methods: {
    close: function close() {
      this.visible = false;
      this.buyParams = null;
    },
    bindEvent: function bindEvent() {
      var _this = this;

      this.eventBus.$on('showSelectPop', function () {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        console.log('event:showSelectPop:call', params);
        _this.visible = true;
        _this.buyParams = params.buyParams;
      });
    },
    launchPowerPop: function launchPowerPop(id) {
      this.eventBus.$emit('showPowerPop', {
        id: id,
        buyParams: this.buyParams
      });
      this.close();
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};